import { membersApi } from '@api/members/members.api';

export const {
  useLazyLoadMembersQuery,
  useAddMemberMutation,
  useAcceptInviteMutation,
  useChangeRoleMutation,
  useDeleteMemberMutation,
  useSuspendMemberMutation,
  useGetInviteInfoQuery,
} = membersApi;
